/**
 * Semantic theme CSS variables exposed to TypeScript consumers.
 *
 * Every value must map to a variable defined in `libs/ui/src/styles/globals.css`
 * and be supported by all theme variants. Keep this registry semantic (primary,
 * muted, border, etc.) rather than palette-coupled (gray-500, teal-50, ...).
 */
export const THEME_CSS_VARS = {
  accent: '--accent',
  background: '--background',
  border: '--border',
  foreground: '--foreground',
  muted: '--muted',
  mutedForeground: '--muted-foreground',
  primary: '--primary',
  primaryForeground: '--primary-foreground',
  secondary: '--secondary',
} as const satisfies Record<string, `--${string}`>;

export type ThemeCssVar = (typeof THEME_CSS_VARS)[keyof typeof THEME_CSS_VARS];
